import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import styled from '@emotion/styled'

import { selectCurrentCategories } from '../../../../flux/selectors/ux'
import { selectLabel } from '../../../../flux/selectors/i18n'
import FilterIconButton from '../FilterIconButton'
import { FilterContext } from '../../../ui/contexts/FilterContext'

const StyledFilter = styled.div(() => ({
  padding: '8px 12px',
  flex: '0 0 auto',
}))

const CategoriesFilterCta = () => {
  const { setFilterOpen } = useContext(FilterContext)
  const currentCategories = useSelector(selectCurrentCategories)
  const filtersLabel = useSelector(selectLabel('filters'))
  const label = `${filtersLabel} ${currentCategories.length > 0 ? `(${currentCategories.length})` : ''}`

  const onFilterIconClick = () => {
    setFilterOpen(true)
  }

  return (
    <StyledFilter>
      <FilterIconButton
        label={label}
        onClick={onFilterIconClick}
      />
    </StyledFilter>
  )
}

CategoriesFilterCta.displayName = 'CategoriesFilterCta'
CategoriesFilterCta.whyDidYouRender = true

export default React.memo(CategoriesFilterCta)
